window.addEventListener('pageshow', () => {
  //detects page navigation using the back/forward button
  jQuery('.init_background').addClass('init')
})

jQuery(function ($) {
  
  // Reset dello scroll e dell'intro. Questo aiuta a prevenire errori con i trigger di GSAP dopo un reload o cambi di pagina.
  // window.onbeforeunload = () => {
  //   $('.init_background')
  //     .removeClass('init')
  //   window.scrollTo(0, 0)
  // };

  $('.init_background').addClass('init')
});